import {NgModule} from '@angular/core';
import {ScrollingBarHorizontalComponent} from './scrolling-bar-horizontal.component';
import {ScrollingBarVerticalComponent} from './scrolling-bar-vertical.component';

@NgModule({
    declarations: [
        ScrollingBarHorizontalComponent,
        ScrollingBarVerticalComponent
    ],
    exports: [
        ScrollingBarHorizontalComponent,
        ScrollingBarVerticalComponent
    ]
})
export class ScrollingBarModule {}
